import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";

export const meBeam = createBeam(bifrost, "/me", {
    unfold:"result",
});


